import { render, staticRenderFns } from "./AnalysesCard.vue?vue&type=template&id=01badaac&"
import script from "./AnalysesCard.vue?vue&type=script&setup=true&lang=ts&"
export * from "./AnalysesCard.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('01badaac')) {
      api.createRecord('01badaac', component.options)
    } else {
      api.reload('01badaac', component.options)
    }
    module.hot.accept("./AnalysesCard.vue?vue&type=template&id=01badaac&", function () {
      api.rerender('01badaac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/[town-translit]/diagnostika/analiz/components/LpuCard/AnalysesCard.vue"
export default component.exports